<template>
  <div class="container" v-if="this.datosRegistro != null">

    <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
      <div
          class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
        <div class="mb-4 mb-xl-0">
          <div class="fs-3 fw-bold text-white">
            <span>Gestionar Permisos del Perfil <span class="badge">{{original.perfil}}</span></span>
          </div>
        </div>
      </div>
    </aside>

    <div class="row mt-3">
      <div class="col-md-3" v-for="p in datosRegistro.lstPermisos" :key="p.id_permiso">
        <div class="form-check form-switch" >
          <input class="form-check-input" type="checkbox" role="switch" :id="'switch-'+p.id_permiso" v-model="p.asignado"
                 @change="actualizar(p)">
          <label class="form-check-label" :for="'switch-'+p.id_permiso">{{p.nombre_permiso}}</label>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col" align="center">
        <button class="btn btn-info " @click="cancelar()">Regresar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {inject} from "vue";
import {PerfilPermisosService} from "@/services/PerfilPermisosService";

export default {
  components: {},

  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_PerfilPermisoService: new PerfilPermisosService(inject('$axios'))
    }
  },
  props: {
    original: Object
  },
  data() {
    return {
      datosRegistro: {
        id_perfil: null,
        lstPermisos: []
      }
    }
  },
  mounted() {
    if (this.original != null && this.original.id != null) {
      this.obtener();
    }
  },
  methods: {
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_PerfilPermisoService.obtener({id_perfil: ""+this.original.id}).then((response) => {
        this.datosRegistro.id_perfil = this.original.id;
        this.datosRegistro.lstPermisos = response
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async actualizar(item) {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      const params = {
        id_perfil: this.datosRegistro.id_perfil,
        id_permiso: item.id_permiso
      }

      if (item.asignado != null && item.asignado) {

        await this.srv_PerfilPermisoService.registro(params).then(() => {

        }).catch((error) => {
          item.asignado = false;
          console.error(error)
          this.$swal(error.message);
        }).finally(() => load.hide());

      } else {

        await this.srv_PerfilPermisoService.eliminar(params).then(() => {

        }).catch((error) => {
          item.asignado = true;
          console.error(error)
          this.$swal(error.message);
        }).finally(() => load.hide());

      }
    },
    cancelar() {
      this.$emit('_cancelarEditar');
    }
  }
}
</script>

<style scoped>
  .badge {
    font-weight: bolder;
    border: solid white;
    border-radius: 20px;
    padding: 3px;
  }
</style>